module.exports = __webpack_public_path__ + "img/link.4da959be.svg";